import { useState, useCallback, useMemo, useLayoutEffect } from 'react'

export const useNavigator = () => {
  const [cameraAccess, setCameraAccess] = useState<boolean | null>(null)
  const [microphoneAccess, setMicrophoneAccess] = useState<boolean | null>(null)

  const isSafariOnMac = useMemo(() => {
    const userAgent = navigator.userAgent

    const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent)
    const isMac = /Macintosh/.test(userAgent)

    return isSafari && isMac
  }, [])

  const checkPermissionOnClick = useCallback(async () => {
    const cameraPermission = await navigator?.permissions?.query({
      name: 'camera' as PermissionName,
    })

    const microphonePermission = await navigator?.permissions?.query({
      name: 'microphone' as PermissionName,
    })

    let cameraAcc: boolean
    let microphoneAcc: boolean

    if (isSafariOnMac) {
      if (typeof cameraPermission === 'undefined') {
        cameraAcc = true
      } else {
        cameraAcc = cameraPermission?.state === 'granted'
      }
      if (typeof microphonePermission === 'undefined') {
        microphoneAcc = true
      } else {
        microphoneAcc = microphonePermission?.state === 'granted'
      }
    } else {
      cameraAcc = cameraPermission?.state !== 'denied'
      microphoneAcc = microphonePermission?.state !== 'denied'
    }

    setMicrophoneAccess(microphoneAcc)
    setCameraAccess(cameraAcc)

    return {
      microphoneAccess: microphoneAcc,
      cameraAccess: cameraAcc,
    }
  }, [isSafariOnMac])

  useLayoutEffect(() => {
    const setPermissions = async () => {
      const cameraPermission = await navigator?.permissions?.query({
        name: 'camera' as PermissionName,
      })

      const microphonePermission = await navigator?.permissions?.query({
        name: 'microphone' as PermissionName,
      })

      if (typeof cameraPermission === 'undefined') {
        return setCameraAccess(true)
      }

      if (typeof microphonePermission === 'undefined') {
        return setMicrophoneAccess(true)
      }

      setCameraAccess(cameraPermission?.state !== 'denied')
      setMicrophoneAccess(microphonePermission?.state !== 'denied')

      cameraPermission.onchange = function () {
        setCameraAccess(cameraPermission?.state !== 'denied')
      }

      microphonePermission.onchange = function () {
        setMicrophoneAccess(microphonePermission?.state !== 'denied')
      }
    }

    setPermissions()
  }, [])

  return { cameraAccess, microphoneAccess, checkPermissionOnClick }
}
